// clientes.service.ts
import { Injectable } from '@angular/core';
import { Http, URLSearchParams, ResponseContentType } from '@angular/http';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ConstantsService } from './constants.service';
import { AutenticacionService } from './autenticacion.service';
import { ValidatorService } from './tools/validator.service';
import { ErrorsService } from './tools/errors.service';
import { of } from 'rxjs/observable/of';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

const PARAMS = new HttpParams({
    fromObject: {
        action: 'opensearch',
        format: 'json',
        origin: '*'
    }
});

@Injectable()
export class ClientesService {

    private service_url: string;

    constructor(
        private constantsService: ConstantsService,
        private http: Http,
        private authService: AutenticacionService,
        private validatorService: ValidatorService,
        private errorService: ErrorsService,
        private httpClient: HttpClient
    ) {
        this.service_url = this.constantsService.apiURL + '/clientes';
    }

    /** * Obtiene el listado paginado para la tabla con filtros aplicados
     */
    public getAll(filters: any) {
        let myParams = new URLSearchParams();

        if (filters.paginate) {
            myParams.append('paginate', 'true');
        }

        if (filters.page) {
            myParams.append('page', filters.page);
        }

        if (filters.search) {
            myParams.append('search', filters.search);
        }

        if (filters.order) {
            myParams.append('order', filters.order);
        }

        let myoptions = this.authService.getAuthHeaders();
        myoptions.params = myParams;

        return this.http.get(this.service_url, myoptions);
    }

    public get(id: number) {
        return this.http.get(this.service_url + "/" + id, this.authService.getAuthHeaders());
    }

    public getById(id: number) {
        return this.http.get(this.service_url + "/" + id, this.authService.getAuthHeaders());
    }

    /** * Elimina un cliente por ID (Borrado lógico)
     */
    public delete(id: number) {
        return this.http.delete(this.service_url + "/" + id, this.authService.getAuthHeaders());
    }

    public save(cliente: object) {
        return this.http.post(this.service_url, cliente, this.authService.getAuthHeaders());
    }

    public create(cliente: any) {
        return this.http.post(this.service_url, cliente, this.authService.getAuthHeaders());
    }

    public update(id: number, cliente: any) {
        // Va hacia: /clientes/2554
        // De esta forma Lumen sabe que es una actualización gracias al {id}
        return this.http.post(`${this.service_url}/${id}`, cliente, this.authService.getAuthHeaders());
}

    public validate(cliente: any) {
        let error = [];

        if (!this.validatorService.required(cliente.nombre)) {
            error["nombre"] = this.errorService.required;
        }

        // if (!this.validatorService.required(cliente.direccion)) {
        //     error["direccion"] = this.errorService.required;
        // }

        if (!this.validatorService.required(cliente.telefono)) {
            error["telefono"] = this.errorService.required;
        }

        if (!this.validatorService.required(cliente.email)) {
            error["email"] = this.errorService.required;
        }

        return error;
    }

    public search(filters: any) {
        const headers = this.authService.getHttpClientHeaders();
        let requestdata = {
            params: null,
            headers: headers
        };

        if (filters.nombre) {
            if (filters.nombre.length <= 2) {
                return of([]);
            }
            requestdata.params = PARAMS.set('nombre', filters.nombre);
        }

        if (filters.email) {
            if (filters.email.length <= 2) {
                return of([]);
            }
            requestdata.params = PARAMS.set('email', filters.email);
        }

        if (!requestdata.params) {
            return of([]);
        }

        return this.httpClient
            .get(this.service_url, requestdata).pipe(
                map(function (response: any) {
                    return response.content;
                })
            );
    }

    public getFile(idArchivo: number) {
        let myParams = new URLSearchParams();
        myParams.append('action', 'download');

        const options = this.authService.getAuthHeaders();
        options.params = myParams;
        options.responseType = ResponseContentType.Blob;

        // Ajuste: Inyectamos '/documento/' entre la base y el ID
        // Si service_url es '.../api/clientes', esto resultará en '.../api/clientes/documento/1'
        let service = this.service_url.replace('/clientes', '/clientes/documento');
        service += '/' + idArchivo;

        return this.http.get(service, options);
    }



}


// WEBPACK FOOTER //
// ./src/app/services/clientes.service.ts